<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">M<span class="small">APS</span></p>
<p class="toc1a"><a href="#/chapter01#map1">“The Major Sites of the Campaigns of 1776–1777”</a></p>
<p class="toc1a"><a href="#/chapter01#map2">Lieutenant Desmaretz Durnford’s Map of the Bennington Battlefield</a></p>
<p class="toc1a"><span href="#/chapter02#map3" title="Link target outside of Sample">“Plan of Bennington Battleground”</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?1fd18d21